import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

let config;

switch (process.env.REACT_APP_ENV) {
  case 'qa':
    config = require('./config/firebase.qa').firebaseConfig;
    break;
  case 'prod':
    config = require('./config/firebase.prod').firebaseConfig;
    break;
  case 'dev':
  default:
    config = require('./config/firebase.dev').firebaseConfig;
    break;
}

//console.log('Using Firebase config:', config); 

const app = initializeApp(config);
export const auth = getAuth(app);
export const db = getFirestore(app);